import React from "react";

import QuestionCircleIcon from "@atlaskit/icon/glyph/question-circle";
import PeopleIcon from "@atlaskit/icon/glyph/people";

import { Box } from "../../UI/Box";
import { Grid } from "../../UI/Grid";
import { COLOR_FIORD, COLOR_GRAY_CHATEAU } from "../../constants/styles";

interface IProps {
  height: number;
}

export const QuestionIcons: React.FC<IProps> = (props) => (
  <Grid container direction="column" alignItems="center">
    <Grid item xs>
      <QuestionCircleIcon label="question circle" primaryColor={COLOR_FIORD} />
    </Grid>
    <Grid item xs mt={1} mb={0.5}>
      <Box height={4} width={4} borderRadius={4} bgcolor={COLOR_GRAY_CHATEAU} />
    </Grid>
    <Grid item xs>
      <Box height={props.height} border={`1px dashed ${COLOR_GRAY_CHATEAU}`} />
    </Grid>
    <Grid item xs mt={0.5} mb={1}>
      <Box height={4} width={4} borderRadius={4} bgcolor={COLOR_GRAY_CHATEAU} />
    </Grid>
    <Grid item xs>
      <PeopleIcon label="people" primaryColor={COLOR_FIORD} />
    </Grid>
  </Grid>
);
